import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: colors.whiteBlue,
    marginBottom: theme.spacing(7),
    padding: theme.spacing(6),
    minHeight: theme.spacing(50),
    height: "100%",
  },
}));
export default useStyles;
